import { defineAsyncComponent } from 'vue'

const GuDatagridClient = defineAsyncComponent(() => import('./components/GuDatagridClient.vue'))
const GuDatagridServer = defineAsyncComponent(() => import('./components/GuDatagridServer.vue'))

export { GuDatagridClient, GuDatagridServer }
